import React, { useContext, useState, useEffect } from 'react';
import {
    Tooltip, makeStyles, Menu, MenuItem,
    useMediaQuery,
} from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import {
    Settings as SettingsIcon,
    PowerSettingsNew as PowerSettingsNewIcon,
    DriveEtaOutlined as DriveEtaOutlinedIcon,
    PeopleOutline as PeopleOutlineIcon,
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import avatarUser from 'assets/user/userDefault.jpg';
import {
    Link,
    useHistory,
    withRouter,
} from 'react-router-dom';
import { ReactComponent as DealsOutlined } from 'assets/deals.svg';
import { ReactComponent as TextsmsOutlined } from 'assets/chat.svg';
import { ReactComponent as LeadOutlined } from 'assets/lead.svg';
import { ReactComponent as FilterOutlined } from 'assets/general/filter.svg';
import { ReactComponent as CollectionOutlined } from 'assets/general/collection.svg';
import { ReactComponent as PartOutlined } from 'assets/general/part.svg';
import { ReactComponent as ServiceOutlined } from 'assets/general/service.svg';
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import PlaylistPlayOutlinedIcon from '@material-ui/icons/PlaylistPlayOutlined';
import KeyStore from 'utils/KeyStore';
import Permission from 'utils/enum/Permissions';
import { modules as appModule, HR_SUBMODULES, COLLECTIONS_SUBMODULES } from 'utils/enum/modules';
import PREFERENCES_KEY from 'utils/enum/UserSettingEnum';
import {
    AccountBalanceOutlinedIcon, ArrowBackIosIcon, ArrowForwardIosIcon,
    DashboardOutlinedIcon, FiberManualRecordOutlinedIcon, HomeOutlinedIcon,
    AssessmentOutlinedIcon, DeskingIcon, TvOutlinedIcon,
    AppraisalsIcon, BIIcon, AssignmentOutlinedIcon, SupervisorAccount,
    AccountTreeOutlinedIcon, CalendarTodayOutlinedIcon, EventAvailableOutlinedIcon,
    SettingsOutlinedIcon, NoEncryptionOutlinedIcon, BrushOutlinedIcon,
} from 'components/icons';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import AirplayOutlinedIcon from '@material-ui/icons/AirplayOutlined';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import {
    ProSidebar, SidebarHeader, SidebarFooter, SidebarContent,
    Menu as MenuSidebar, MenuItem as MenuItemSidebar, SubMenu,
} from 'react-pro-sidebar';
import SwitchCompany from 'components/layout/SwitchCompany';
import NotificationBadge, { TYPE } from 'components/layout/NotificationBadge';
import UserContext from 'components/context/UserContext';
import useLogOut from 'components/hook/core/useLogOut';
import clsx from 'clsx';

import { lockAndPlayBellSound } from 'utils/SoundService';
import { useQuery, useSubscription } from '@apollo/client';
import { FetchPolicy } from 'utils/enum/Core';
import UserNotificationQuery from 'services/graphQL/query/core/UserNotificationQuery';
import NotificationSubscription from 'services/graphQL/subscription/core/NotificationSubscription';
import 'components/layout/menu.scss';
import GeneralUtils from 'utils/GeneralUtils';
import StringUtils from 'lib/StringUtils';
import UserUtils from 'utils/UserUtils';
import SideBarStyles from 'styles/layout/SideBar';

const {
    REACT_APP_SUPPORT_PHONE_NUMBER,
    REACT_APP_WEEK_SUPPORT_HOURS,
    REACT_APP_TIMECLOCK_HTTP,
    REACT_APP_MEETING_HTTP,
} = process.env;
const NavMenu = (props) => {
    const isMobile = useMediaQuery('(max-width:992px)');
    const isTablet = useMediaQuery('(min-width:992px) and (max-width:1024px)');
    const history = useHistory();
    const keyStore = new KeyStore();
    const isTimeclockDomain = window.location.hostname === new URL(REACT_APP_TIMECLOCK_HTTP).hostname;
    const skipSubscription = !keyStore.exists() || isTimeclockDomain;
    const isSidebarOpened = !skipSubscription ? keyStore.isSidebarOpened() : false;
    const { externalOpen, setToogleMobile } = props;
    const { logOut, executingLogOut } = useLogOut();
    const [anchorEl, setAnchorEl] = useState(null);
    const [openSidebar, setOpenSidebar] = useState(isSidebarOpened);
    const [selected, setSelected] = useState();

    const CRM_MESSAGE_CENTER_READ = !skipSubscription ? keyStore.hasPermission(Permission.CRM_MESSAGE_CENTER_READ) : false;
    const CRM_MAILBOX_READ = !skipSubscription ? keyStore.hasPermission(Permission.CRM_MAILBOX_READ) : false;

    const canReadCollections = !skipSubscription ? keyStore.hasPermission(Permission.COLLECTION_READ) : false;
    const {
        data: collectionsNotificationsData,
        refetch: refetchCollectionsNotifications,
    } = useQuery(
        UserNotificationQuery.GET_TOTAL_NOTIFICATIONS,
        {
            fetchPolicy: FetchPolicy.NETWORK_ONLY,
            skip: !canReadCollections,
        },
    );

    const { data: companyCommunicationData } = useSubscription(
        NotificationSubscription.COMPANY_COMMUNICATION_NOTIFICATIONS_MODIFIED,
        { skip: !canReadCollections },
    );

    const { data: taskDueData } = useSubscription(
        NotificationSubscription.TASK_DUE_NOTIFICATIONS_MODIFIED,
        { skip: !canReadCollections },
    );

    useEffect(() => {
        if (!canReadCollections || !refetchCollectionsNotifications) return;

        const comunicationCounter = companyCommunicationData?.companyCommunicationCounterChanged;
        const taskDueCounter = taskDueData?.userTaskDueCounterChanged;

        if (comunicationCounter || taskDueCounter) refetchCollectionsNotifications();
    }, [canReadCollections, refetchCollectionsNotifications, companyCommunicationData, taskDueData]);

    useEffect(() => {
        if (!canReadCollections || !refetchCollectionsNotifications) return;

        if (companyCommunicationData?.companyCommunicationCounterChanged?.notificationSoundEnabled) lockAndPlayBellSound();
    }, [canReadCollections, refetchCollectionsNotifications, companyCommunicationData]);

    useEffect(() => {
        if (!canReadCollections || !refetchCollectionsNotifications) return;

        if (taskDueData?.userTaskDueCounterChanged?.notificationSoundEnabled) lockAndPlayBellSound();
    }, [canReadCollections, refetchCollectionsNotifications, taskDueData]);

    const collectionsNotificationCount = collectionsNotificationsData?.getTotalNotifications ?? 0;

    const context = useContext(UserContext);
    const { userInformation: userData, userSettings, colors } = context ?? {};

    const classes = makeStyles((sideBarTheme) => SideBarStyles.main({ theme: sideBarTheme, colors }))();

    const { userPreferences = [] } = userSettings ?? {};
    const { location = {} } = history;
    const { pathname = '', hash = '' } = location;
    const normalizePath = (path) => {
        if (path === '/' || path === '') return path;
        return path.endsWith('/') ? path.slice(0, -1) : path;
    };

    const urlBelongsToLocation = (url) => {
        if (!url) return false;

        const pathnameNormalized = normalizePath(pathname.toLowerCase());
        const urlNormalized = normalizePath(url.toLowerCase());

        if (pathnameNormalized.includes(appModule.SETTINGS.toLowerCase())) {
            return pathnameNormalized === urlNormalized;
        }

        if (pathnameNormalized.includes(appModule.ACCOUNTING.toLowerCase())) {
            return urlNormalized.includes(appModule.ACCOUNTING.toLowerCase());
        }

        if (pathnameNormalized.includes(appModule.INVENTORY.toLowerCase())) {
            return pathnameNormalized === urlNormalized;
        }

        if (pathnameNormalized === urlNormalized) {
            return true;
        }

        if (pathnameNormalized.startsWith(urlNormalized)) {
            const nextChar = pathnameNormalized[urlNormalized.length];
            return nextChar === '/' || nextChar === undefined;
        }

        return false;
    };

    const openInNewTab = userPreferences.find((s) => s.key === PREFERENCES_KEY.OPENING_BEHAVIOR)?.value ?? 'false';
    const createSideBar = (items, comeFromParent) => items.filter((c) => c.access).map((item) => {
        if (item?.children?.length > 0) {
            const haveAnyChildrenActive = item.children?.find((c) => c.id === selected || urlBelongsToLocation(c.to));
            return isSidebarOpened ? (
                <SubMenu
                    key={item.id}
                    title={item.text}
                    icon={item.icon}
                    open={haveAnyChildrenActive}
                    className={clsx(
                        classes.subMenuHover,
                        { [classes.subMenuActive]: haveAnyChildrenActive },
                    )}
                >
                    {createSideBar(item.children, true)}
                </SubMenu>
            )
                : (
                    <Tooltip title={item.text} key={item.id}>
                        <SubMenu
                            icon={item.icon}
                            open={haveAnyChildrenActive}
                            className={clsx(
                                classes.subMenuHover,
                                { [classes.subMenuActive]: haveAnyChildrenActive },
                            )}
                        >
                            {createSideBar(item.children, true)}
                        </SubMenu>
                    </Tooltip>
                );
        }
        return (
            <Tooltip title={isSidebarOpened || comeFromParent ? '' : item.text} key={item.id}>
                <MenuItemSidebar
                    icon={item.icon}
                    onClick={() => {
                        if (item.onClick) { item.onClick(); return; }
                        if (StringUtils.isEmpty(item.toExternal) && openInNewTab !== 'true') setSelected(item.id);
                    }}
                    active={item.id === selected || urlBelongsToLocation(item.to)}
                    className={clsx(
                        { [classes.menuActive]: item.id === selected || urlBelongsToLocation(item.to) },
                        classes.menuHover,
                    )}
                >
                    {item.text}
                    {item.to && <Link to={item.to} {...(openInNewTab === 'true' ? { target: '_blank' } : {})} />}
                    {item.toExternal && <Link to={{ pathname: item.toExternal }} target="_blank" />}
                </MenuItemSidebar>
            </Tooltip>
        );
    });

    const saveStatusSidebar = (value) => {
        keyStore.setSidebarCollapsed(value);
        setOpenSidebar(value);
    };

    const getCurrentItemSelected = (items) => items.filter((c) => c.access).forEach((item) => {
        if (item?.children?.length > 0) {
            getCurrentItemSelected(item.children);
        }
        if (urlBelongsToLocation(item.to)) {
            setSelected(item.id);
        }
    });

    const openTraining = () => {
        window.open(`/${appModule.TRAINING}?path=${pathname}&hash=${hash}`, '_blank').focus();
    };

    const openMeeting = () => {
        window.open(REACT_APP_MEETING_HTTP, '_blank').focus();
    };

    const openFeedbackWidget = () => {
        const label = document.getElementById('feedbacklabel');
        if (label !== null) {
            // eslint-disable-next-line no-undef
            const evt = new MouseEvent('click');
            label.dispatchEvent(evt);
        }
    };

    const menuTree = [
        {
            text: 'Home',
            to: '/home',
            icon: <HomeOutlinedIcon />,
            access: true,
            id: 'm1',
        },
        {
            text: 'Business Intelligence',
            to: null,
            icon: <BIIcon className={classes.customIcon} />,
            access: keyStore.hasPermission(Permission.BI_READ),
            id: 'm2',
            children: [
                {
                    text: 'Dashboard',
                    to: `/${appModule.DASHBOARD}`,
                    icon: <DashboardOutlinedIcon />,
                    access: keyStore.hasPermission(Permission.BI_DASHBOARD_READ),
                    id: 'm2-1',
                },
                {
                    text: 'Custom Reports',
                    to: `/${appModule.CUSTOM_REPORTS}`,
                    icon: <AssignmentOutlinedIcon />,
                    access: keyStore.hasPermission(Permission.BI_CUSTOM_REPORTS_READ),
                    id: 'm2-2',
                },
                {
                    text: 'Rules',
                    to: `/${appModule.RULES}`,
                    icon: <BIIcon className={classes.customIcon} />,
                    access: keyStore.hasPermission(Permission.BI_RULES_READ),
                    id: 'm2-3',
                },
                {
                    text: 'Queries',
                    to: `/${appModule.QUERIES}`,
                    icon: <PlaylistPlayOutlinedIcon />,
                    access: keyStore.hasPermission(Permission.BI_QUERY_READ),
                    id: 'm2-4',
                },
            ],
        },
        {
            text: 'Inventory',
            to: '/inventory',
            icon: <DriveEtaOutlinedIcon />,
            access: keyStore.hasPermission(Permission.INVENTORY_READ),
            id: 'm3',
        },
        {
            text: 'Desking',
            to: null,
            icon: <DeskingIcon className={classes.customIcon} />,
            access: true,
            id: 'm15',
            children: [
                {
                    text: 'Payment Calls',
                    to: `/${appModule.INVENTORY}/payment-calls`,
                    icon: <DeskingIcon className={classes.customIcon} />,
                    access: true,
                    id: 'm15-1',
                },
                {
                    text: 'Payment Calculator',
                    to: `/${appModule.OTHER}/payment-calculator`,
                    icon: <MonetizationOnIcon />,
                    access: true,
                    id: 'm15-2',
                },
                {
                    text: 'Appraisals',
                    to: `/${appModule.INVENTORY}/appraisals`,
                    icon: <AppraisalsIcon />,
                    access: keyStore.hasPermission(Permission.INVENTORY_APPRAISALS_READ),
                    id: 'm15-3',
                },
            ],
        },
        {
            text: 'Deals',
            to: '/deals',
            icon: <DealsOutlined className={classes.icon} />,
            access: keyStore.hasPermission(Permission.SALES_READ),
            id: 'm4',
        },
        {
            text: 'CRM',
            to: null,
            icon: <LeadOutlined className={classes.icon} />,
            access: true,
            id: 'm5',
            children: [
                {
                    text: 'Message Center',
                    to: `/${appModule.COMMUNICATION}`,
                    icon: <ForumOutlinedIcon />,
                    access: CRM_MESSAGE_CENTER_READ || CRM_MAILBOX_READ,
                    id: 'm5-1',
                },
                {
                    text: 'Opportunities',
                    to: `/${appModule.OPPORTUNITIES}`,
                    icon: <FilterOutlined className={classes.customIcon} />,
                    access: keyStore.hasPermission(Permission.CRM_OPPORTUNITY_READ),
                    id: 'm5-2',
                },
                {
                    text: 'Calendar',
                    to: `/${appModule.CALENDAR}`,
                    icon: <CalendarTodayOutlinedIcon />,
                    access: keyStore.hasPermission(Permission.CRM_OPPORTUNITY_READ),
                    id: 'm5-3',
                },
                {
                    text: 'Chat',
                    to: '/conversations',
                    icon: <TextsmsOutlined className={classes.icon} />,
                    access: keyStore.hasPermission(Permission.CRM_CONVERSATION_READ),
                    id: 'm5-4',
                },
                {
                    text: 'Customers',
                    to: '/customers',
                    icon: <PeopleOutlineIcon />,
                    access: keyStore.hasPermission(Permission.CUSTOMER_READ),
                    id: 'm5-5',
                },
                {
                    text: 'Floor Log',
                    to: '/floorlog',
                    icon: <TvOutlinedIcon />,
                    access: keyStore.hasPermission(Permission.CRM_OPPORTUNITY_READ),
                    id: 'm5-6',
                },
                {
                    text: 'AI Calls & Web Chats',
                    to: '/ai-calls-web-chats',
                    icon: <CallOutlinedIcon />,
                    access: keyStore.hasPermission(Permission.CRM_OPPORTUNITY_READ)
                        || keyStore.hasPermission(Permission.CRM_MAILBOX_READ)
                        || keyStore.hasPermission(Permission.CRM_MESSAGE_CENTER_READ),
                    id: 'm5-7',
                },
            ],
        },
        {
            id: 'm9',
            text: 'Collections',
            icon: <CollectionOutlined className={classes.customIcon} />,
            access: keyStore.hasPermission(Permission.COLLECTION_READ),
            to: null,
            children: [
                {
                    id: 'm9-0',
                    text: 'Collections',
                    icon: <CollectionOutlined className={classes.customIcon} />,
                    to: `/${appModule.COLLECTIONS}/${COLLECTIONS_SUBMODULES.ACCOUNTS}`,
                    access: keyStore.hasPermission(Permission.COLLECTION_ACCOUNT_READ),
                },
                {
                    id: 'm9-1',
                    text: 'Queue Accounts',
                    icon: <AssignmentOutlinedIcon />,
                    to: `/${appModule.COLLECTIONS}/${COLLECTIONS_SUBMODULES.QUEUE_ACCOUNT}`,
                    access: keyStore.hasPermission(Permission.COLLECTION_READ),
                },
                {
                    id: 'm9-2',
                    text: 'Credit Reporting',
                    icon: <AssessmentOutlinedIcon />,
                    to: `/${appModule.COLLECTIONS}/${COLLECTIONS_SUBMODULES.CREDIT_REPORTING}`,
                    access: keyStore.hasPermission(Permission.COLLECTION_CREDIT_REPORTING_READ),
                },
                {
                    id: 'm9-3',
                    text: 'Settings',
                    icon: <SettingsOutlinedIcon />,
                    to: `/${appModule.COLLECTIONS}/${COLLECTIONS_SUBMODULES.SETTINGS_GENERAL}`,
                    access: keyStore.hasPermission(Permission.COLLECTION_SETTING_READ),
                },
                {
                    id: 'm9-4',
                    text: 'Message Center',
                    icon: <ForumOutlinedIcon />,
                    to: `/${appModule.COLLECTIONS}/${COLLECTIONS_SUBMODULES.MESSAGE_CENTER}`,
                    access: keyStore.hasPermission(Permission.COLLECTION_READ),
                },
                {
                    id: 'm9-5',
                    text: 'AI Calls',
                    icon: <CallOutlinedIcon />,
                    to: `/${appModule.COLLECTIONS}/${COLLECTIONS_SUBMODULES.AI_CALLS}`,
                    access: keyStore.hasPermission(Permission.COLLECTION_READ),
                },
            ],
        },
        {
            text: 'Parts',
            to: `/${appModule.PARTS}`,
            icon: <PartOutlined className={classes.customIcon} />,
            access: keyStore.hasPermission(Permission.PARTS_READ),
            id: 'm14',
        },
        {
            text: 'Service',
            to: `/${appModule.SERVICE}`,
            icon: <ServiceOutlined className={classes.customIcon} />,
            access: keyStore.hasPermission(Permission.SERVICE_READ),
            id: 'm16',
        },
        {
            id: 'm8',
            text: 'HR',
            icon: <SupervisorAccount />,
            access: keyStore.hasPermission(Permission.PAYROLL_READ)
                || keyStore.hasPermission(Permission.HR_READ)
                || keyStore.hasPermission(Permission.HR_LOGIN_PERMISSION_READ),
            to: null,
            children: [
                {
                    id: 'm8-0',
                    text: 'Employee Settings',
                    icon: <SupervisorAccount />,
                    to: `/${appModule.HR}/${HR_SUBMODULES.EMPLOYEE_SETTINGS}`,
                    access: keyStore.hasPermission(Permission.HR_READ),
                },
                {
                    id: 'm8-8',
                    text: 'Login and Permission',
                    icon: <VpnKeyOutlinedIcon />,
                    to: `/${appModule.HR}/${HR_SUBMODULES.LOGIN_AND_PERMISSION}`,
                    access: keyStore.hasPermission(Permission.HR_LOGIN_PERMISSION_READ),
                },
                {
                    id: 'm8-1',
                    text: 'Payroll',
                    to: `/${appModule.PAYROLL}`,
                    icon: <AssignmentIndOutlinedIcon />,
                    access: keyStore.hasPermission(Permission.PAYROLL_READ),
                },
                {
                    id: 'm8-2',
                    text: 'Organizational Chart',
                    icon: <AccountTreeOutlinedIcon />,
                    to: `/${appModule.HR}/${HR_SUBMODULES.ORGANIZATIONAL_CHART}`,
                    access: keyStore.hasPermission(Permission.HR_READ),
                },
                {
                    id: 'm8-3',
                    text: 'Asset Inventory',
                    icon: <AssignmentOutlinedIcon />,
                    to: `/${appModule.HR}/${HR_SUBMODULES.ASSET_INVENTORY}`,
                    access: keyStore.hasPermission(Permission.HR_READ),
                },
                {
                    id: 'm8-4',
                    text: 'Calendar',
                    icon: <CalendarTodayOutlinedIcon />,
                    to: `/${appModule.HR}/${HR_SUBMODULES.CALENDAR}`,
                    access: keyStore.hasPermission(Permission.HR_READ),
                },
                {
                    id: 'm8-5',
                    text: 'Work Schedule',
                    icon: <EventAvailableOutlinedIcon />,
                    to: `/${appModule.HR}/${HR_SUBMODULES.WORK_SCHEDULE}`,
                    access: keyStore.hasPermission(Permission.HR_READ),
                },
                {
                    id: 'm8-6',
                    text: 'Settings',
                    icon: <SettingsOutlinedIcon />,
                    to: `/${appModule.HR}/${HR_SUBMODULES.SETTINGS}`,
                    access: keyStore.hasPermission(Permission.HR_READ),
                },
                {
                    id: 'm8-7',
                    text: 'Accounts Locked',
                    icon: <NoEncryptionOutlinedIcon />,
                    to: `/${appModule.HR}/${HR_SUBMODULES.LOCKED_USER}`,
                    access: keyStore.hasPermission(Permission.HR_READ),
                },
            ],
        },
        {
            text: 'Reports',
            to: null,
            icon: <AssessmentOutlinedIcon />,
            access: keyStore.hasPermission(Permission.REPORTS_INVENTORY_READ),
            id: 'm10',
            children: [
                {
                    id: 'm10-0',
                    text: 'Reports',
                    icon: <FiberManualRecordOutlinedIcon fontSize="small" />,
                    access: keyStore.hasPermission(Permission.REPORTS_READ),
                    toExternal: `${process.env.REACT_APP_REPORTS_HTTP}`,
                },
                {
                    text: 'Recon',
                    to: `/${appModule.REPORTS}/recon`,
                    icon: <FiberManualRecordOutlinedIcon fontSize="small" />,
                    access: keyStore.hasPermission(Permission.REPORTS_INVENTORY_READ),
                    id: 'm10-1',
                },
                {
                    text: 'Appraisal History',
                    to: `/${appModule.REPORTS}/appraisal-history`,
                    icon: <FiberManualRecordOutlinedIcon fontSize="small" />,
                    access: keyStore.hasPermission(Permission.REPORTS_INVENTORY_READ),
                    id: 'm10-2',
                },
                {
                    text: 'Sales Tax',
                    to: `/${appModule.REPORTS}/sales-tax`,
                    icon: <FiberManualRecordOutlinedIcon fontSize="small" />,
                    access: keyStore.hasPermission(Permission.REPORTS_FINANCIALS_READ),
                    id: 'm10-3',
                },
                {
                    text: 'Inventory Tax',
                    to: `/${appModule.REPORTS}/inventory-tax`,
                    icon: <FiberManualRecordOutlinedIcon fontSize="small" />,
                    access: keyStore.hasPermission(Permission.REPORTS_FINANCIALS_READ),
                    id: 'm10-4',
                },
            ],
        },
        {
            text: 'Settings',
            to: `/${appModule.SETTINGS}`,
            icon: <SettingsIcon />,
            access: keyStore.hasPermission(Permission.SETTINGS_READ),
            id: 'm11',
        },
        {
            text: 'Preferences',
            to: `/${appModule.PREFERENCES}`,
            icon: <BrushOutlinedIcon />,
            access: keyStore.hasPermission(Permission.USER_EMAIL_SIGNATURE_READ) || keyStore.hasPermission(Permission.CORE_USER_READ),
            id: 'm19',
        },
        {
            text: 'Help',
            icon: <HelpOutlineOutlinedIcon className={classes.helpIcon} />,
            access: true,
            id: 'm_help',
            children: [
                {
                    text: 'Support Desk',
                    icon: <ForumOutlinedIcon className={classes.supportIcon} />,
                    access: true,
                    id: 'm_help_1',
                    onClick: openFeedbackWidget,
                },
                {
                    text: 'Join a Meeting',
                    icon: <AirplayOutlinedIcon className={classes.videoCallIcon} />,
                    access: true,
                    id: 'm_help_2',
                    onClick: openMeeting,
                },
                {
                    text: 'Training',
                    icon: <HelpOutlineOutlinedIcon className={classes.helpIcon} />,
                    access: true,
                    id: 'm_help_3',
                    onClick: openTraining,
                },
                {
                    text: 'Release Notes',
                    to: '/release-notes',
                    icon: <AnnouncementIcon fontSize="small" />,
                    access: keyStore.hasPermission(Permission.RELEASE_NOTE_READ),
                    id: 'm_help_4',
                },
            ],
        },
    ];

    const isAccountingEnabled = GeneralUtils.isModuleEnabled(context, appModule.ACCOUNTING);
    if (isAccountingEnabled) {
        menuTree.splice(7, 0, {
            text: 'Accounting',
            to: `/${appModule.ACCOUNTING}`,
            icon: <AccountBalanceOutlinedIcon />,
            access: keyStore.hasPermission(Permission.ACCOUNTING_READ),
            id: 'm7',
        });
    }

    useEffect(() => {
        getCurrentItemSelected(menuTree);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    useEffect(() => {
        if (isTablet) {
            setOpenSidebar(false);
        }
    }, [isTablet]);

    return (
        <ProSidebar
            collapsed={!isMobile && !openSidebar}
            toggled={externalOpen}
            onToggle={() => setToogleMobile(!externalOpen)}
            breakPoint="lg"
            className={classes.mobileMenuShow}
        >
            <SidebarHeader className={classes.navHeaderClass}>
                <div>
                    <Avatar
                        aria-controls="basic-menu"
                        alt={userData?.username}
                        src={userData?.userPicture ?? avatarUser}
                        className={classes.userAvatar}
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                    />
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                    >
                        <MenuItem onClick={() => logOut()} disabled={executingLogOut}>
                            <PowerSettingsNewIcon title="Logout" />
                            Logout
                        </MenuItem>
                    </Menu>
                    {((openSidebar && !isMobile) || (externalOpen && isMobile)) && <div>{UserUtils.getUserInformation(userData)}</div>}
                </div>
                <div className={openSidebar || isMobile ? classes.displayRow : ''}>
                    {openSidebar && <SwitchCompany iconColor={colors.headerFontColor} />}
                    <NotificationBadge type={TYPE.COMMUNICATION} iconColor={colors.headerFontColor} />
                    <NotificationBadge type={TYPE.NOTIFICATION} iconColor={colors.headerFontColor} collectionCount={collectionsNotificationCount} />
                </div>
            </SidebarHeader>
            <SidebarContent className={clsx('d-flex-column-align-space-between', classes.contentSideBar)}>
                <MenuSidebar
                    iconShape="circle"
                    popperArrow
                    innerSubMenuArrows
                >
                    {createSideBar(menuTree)}
                </MenuSidebar>
                {openSidebar && (
                    <div className={clsx('d-flex-column-center', classes.contactContainer)}>
                        <span>Support Hours:</span>
                        <span>{REACT_APP_WEEK_SUPPORT_HOURS}</span>
                        <span>{REACT_APP_SUPPORT_PHONE_NUMBER}</span>
                    </div>
                )}
            </SidebarContent>
            <SidebarFooter className={classes.footerSideBar}>
                {!isMobile && openSidebar && (
                    <div className={classes.menuOpened}>
                        <ArrowBackIosIcon onClick={() => saveStatusSidebar(false)} />
                    </div>
                )}
                {!isMobile && !openSidebar && (
                    <div className={classes.menuCollapsed}>
                        <ArrowForwardIosIcon onClick={() => saveStatusSidebar(true)} />
                    </div>
                )}
            </SidebarFooter>
        </ProSidebar>
    );
};

NavMenu.propTypes = {
    externalOpen: PropTypes.bool.isRequired,
    setToogleMobile: PropTypes.func.isRequired,
};

export default withRouter(NavMenu);
